import { Button, CircularProgress } from "@mui/material";
import { getUserStore, type FrontendId } from "../../store/UserStore";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

const ResendVerificationLinkButton = observer(
  ({
    email,
    onSuccess,
    frontendId,
  }: {
    email: string | null;
    onSuccess?: () => void;
    frontendId: FrontendId;
  }) => {
    const { t } = useTranslation();
    const { sendVerificationLink, isSendingLink } = getUserStore(frontendId);

    const sendEmail = async () => {
      const res = await sendVerificationLink(email);
      if (res) {
        onSuccess?.();
      }
    };

    return (
      <Button
        onClick={sendEmail}
        variant="contained"
        disabled={isSendingLink}
        startIcon={isSendingLink ? <CircularProgress size={20} /> : ""}
      >
        {t("login.resendLink")}
      </Button>
    );
  }
);

export default ResendVerificationLinkButton;
